import * as React from 'react';
import { Card, Dropdown, Form, Space } from 'antd';
import { FormProps, Tag } from '../../admin-knowledge-base.type';
import { ANIMATION_DURATION, langLabels, languages } from '../../admin-knowledge-base.constants';
import { memo, useEffect, useRef, useState } from 'react';
import FormButtons from './form-buttons';
import TitleField from './title-field';
import { animateForm } from '../../admin-knowledge-base.utils';
import Button from '/react4xp/mixins/ui/button/button';
import { Languages } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';
import TagIcon, { icons } from '/react4xp/parts/knowledge-base-common/components/tag-icon';

export const TagForm = memo(({ onSubmit, close, form }: FormProps<Tag>) => {
    const [activeLanguage, setActiveLanguage] = useState<Languages>(languages[0]);
    const localizedFieldsRef = useRef<HTMLDivElement>(null);

    const handleLanguageChange = (language: Languages) => {
        setActiveLanguage(language);
        animateForm(localizedFieldsRef.current);
    };

    const icon = Form.useWatch('icon', form);

    useEffect(() => {
        setTimeout(() => {
            form.setFieldValue(['draft', 'title'], form.getFieldValue([activeLanguage, 'title']));
        }, ANIMATION_DURATION / 3);
    }, [activeLanguage]);

    const handleSelectIcon = (icon: string) => {
        form.setFieldValue('icon', icon);
    };

    return (
        <Form
            form={form}
            onFinish={onSubmit}
            validateTrigger={['onBlur']}
        >
            <Form.Item
                hidden
                name="id"
            />
            <Space.Compact>
                {languages.map((language) => (
                    <Button
                        key={language}
                        onClick={() => handleLanguageChange(language)}
                        color={language === activeLanguage ? 'gold' : ''}
                    >
                        {langLabels[language]}
                    </Button>
                ))}
            </Space.Compact>
            <div ref={localizedFieldsRef}>
                <TitleField
                    activeLanguage={activeLanguage}
                    form={form}
                />
            </div>
            <Form.Item
                name="icon"
                label="Иконка"
                labelCol={{ span: 24 }}
                rules={[{ required: true, message: 'Обязательное поле' }]}
            >
                <Dropdown
                    trigger={['click']}
                    dropdownRender={() => (
                        <Card style={{ maxWidth: 400, maxHeight: '30vh', overflowY: 'scroll' }}>
                            <Space wrap>
                                {icons.map((icon) => (
                                    <Button
                                        size="large"
                                        ghost
                                        key={icon}
                                        icon={
                                            <TagIcon
                                                name={icon}
                                                size={24}
                                            />
                                        }
                                        onClick={() => handleSelectIcon(icon)}
                                    />
                                ))}
                            </Space>
                        </Card>
                    )}
                >
                    <button
                        className="icon-preview"
                        onClick={(e: React.MouseEvent) => e.preventDefault()}
                    >
                        <TagIcon
                            name={icon}
                            size={45}
                        />
                    </button>
                </Dropdown>
            </Form.Item>
            <FormButtons close={close} />
        </Form>
    );
});
